import timeUtils from '@/utils/timeUtils.ts';
import { BookingStatus } from '@/types/BookingStatus.ts';
import { BookingListDto } from '@/features/dashboard/bookings/types/BookingListDto.ts';
import { ClientListDto } from '@/features/dashboard/clients/types/ClientListDto.ts';
import { ClientStatus } from '@/features/dashboard/clients/types/ClientStatus.ts';
import { getClientStatusLabel } from '@/features/dashboard/clients/types/ClientStatus.utils.ts';
import { getBookingStatusLabel } from '@/features/dashboard/bookingChanges/types/BillViewModel.utils.ts';
import { pluralizeParticipants } from '@/features/dashboard/bookingChanges/utils/plurals.ts';

export const isCancelledBookingRow = (item: BookingListDto): boolean =>
  item.booking?.status === BookingStatus.CANCELLED;

export const isCancelledClientRow = (item: ClientListDto): boolean =>
  item.client.status === ClientStatus.CANCELLED;

/**
 * Kod rezerwacji idzie na początek: operator ma go z maila i po samej nazwie wyjazdu nie odróżni
 * kilku rezerwacji tego samego klienta.
 */
export const bookingOptionText = (item: BookingListDto): string =>
  `${item.booking?.bookingCode ?? ''} · ${item.tour.name} (${pluralizeParticipants(item.participantCount)}, ${timeUtils.toDateTimeString(item.createdAt)})`;

export const clientOptionText = (item: ClientListDto): string =>
  `${item.client.firstName} ${item.client.lastName} (${item.tour.name})`;

/** Wersja dla czytnika ekranu: przekreślenia nie słychać, więc stan musi paść słowem. */
export const bookingOptionLabel = (item: BookingListDto): string =>
  isCancelledBookingRow(item)
    ? `${bookingOptionText(item)} · ${getBookingStatusLabel(BookingStatus.CANCELLED)}`
    : bookingOptionText(item);

export const clientOptionLabel = (item: ClientListDto): string =>
  isCancelledClientRow(item)
    ? `${clientOptionText(item)} · ${getClientStatusLabel(ClientStatus.CANCELLED)}`
    : clientOptionText(item);
